import $ from 'jquery';

const originalPositions = new WeakMap();

function restoreImageModal(modal) {
  const position = originalPositions.get(modal);
  if (!position) return;
  if (position.parent.isConnected) {
    position.parent.insertBefore(modal, position.next && position.next.parentNode === position.parent ? position.next : null);
  } else {
    $(modal).remove();
  }
  originalPositions.delete(modal);
}

$(document).on('show.bs.modal', '.shared-image-modal', function() {
  if (this.parentNode === document.body) return;
  originalPositions.set(this, { parent: this.parentNode, next: this.nextSibling });
  document.body.appendChild(this);
});

$(document).on('hidden.bs.modal', '.shared-image-modal', function() {
  restoreImageModal(this);
});

$(document).on('click', '.image-preview', function(event) {
  const modal = document.getElementById(this.dataset.modalId);
  if (!modal) return;
  event.preventDefault();
  event.stopPropagation();
  $(modal).modal('show');
});

$(document).on('click', '.shared-image-modal-close', function(event) {
  event.preventDefault();
  $(this).closest('.modal').modal('hide');
});

$(document).on('turbolinks:before-cache', function() {
  document.querySelectorAll('body > .shared-image-modal').forEach(modal => {
    const animated = modal.classList.contains('fade');
    $(modal).removeClass('fade').modal('hide');
    restoreImageModal(modal);
    if (animated) modal.classList.add('fade');
  });
});
